import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagME = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M50 24.999c0-8.58-4.323-16.15-10.91-20.652H10.91C4.323 8.849 0 16.419 0 24.999c0 8.58 4.323 16.15 10.91 20.652h28.18C45.677 41.149 50 33.579 50 24.999Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M19.564 18.48h10.87v-4.348l-2.175 1.086-3.26-3.26-3.261 3.26-2.174-1.086v4.347ZM34.782 25H29.35a2.508 2.508 0 1 0-4.383-2.435A2.507 2.507 0 1 0 20.585 25h-5.367c0 1.663 1.448 3.01 3.11 3.01h-.1a3.01 3.01 0 0 0 2.15 2.885l-2.443 2.443 2.306 2.306 3.27-3.271c.129.047.261.085.398.11l-1.976 4.463a8.125 8.125 0 0 0 3.068.599c1.085 0 2.12-.214 3.067-.6l-1.976-4.462c.137-.025.27-.063.397-.11l3.271 3.27 2.306-2.305-2.443-2.443a3.011 3.011 0 0 0 2.15-2.885h-.1c1.662 0 3.11-1.348 3.11-3.01Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "m25 26.63-3.533 1.63v3.261L25 33.695l3.532-2.174v-3.26L25 26.63Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M21.467 25h7.065v4.348h-7.065V25Z"
}));
FlagME.displayName = 'FlagME';
export default withFlagWrapper(FlagME);
//# sourceMappingURL=index.js.map